<template>
	<div>
		<c-scroll-view scroll-x>
			<div class="process-rate">
				<p v-if="list && !list.length" class="empty flex-center">暂无工单进度数据</p>
				<div v-if="list && list.length" class="flex">
					<template v-for="(item, i) in list">
						<div v-if="i" class="line" :key="`line${i}`"></div>
						<div :key="`item${i}`" class="item flex-column flex-center" @click.stop="detailHandle(item)">
							<c-progress class="circle" :rate="[item.fine_count, item.plan_count]" :color="item.state == 1 ? '#bbb' : item.state == 2 ? '#0D6EFE' : 'main'" type="circle" size="0.88" line-size="0.08" font-size="0.24" :style="{'background': item.state == 1 ? '#F5F5F5' : '#fff'}">
								<template #text="{rate}">
									<span v-if="item.state == 1" style="font-size: .2rem; color: #666;">未开始</span>
									<span v-else-if="rate == 100" style="font-size: .5rem;" :style="{'color': item.state == 2 ? '#0D6EFE' : 'var(--color-main)'}"><i class="c-icon-check"></i></span>
									<span v-else :style="{'color': rate > 100 ? '#f00' : ''}">{{rate.toFixed(0)}}%</span>
								</template>
							</c-progress>
							<p class="flex-center"><span class="ellipsis">{{item.process_name}}</span></p>
							<div v-if="item.process_type == 2" class="tag" :style="{'background': item.out_sourcing_plan_count > 0 ? '#07b966' : '#0D6EFE'}">委外</div>
							<div v-if="item.priority == 1" class="state flex-center" style="background: #f00;"><i class="tf">&#xe657;</i></div>
							<div v-else-if="item.priority == 2" class="state flex-center" style="background: #999;"><i class="tf">&#xe65a;</i></div>
						</div>
					</template>
				</div>
			</div>
		</c-scroll-view>

		<c-dialog ref="detail" :title="false" width="88%" position="center" mask-close :close-button="false" :button="false">
			<div v-if="detailData" class="process-rate-detail">
				<div class="head flex-between-center">
					<p class="flex-grow ellipsis">{{detailData.process_name}}</p>
					<c-state dict="orderStateDic" tag :value="detailData.state"></c-state>
				</div>
				<ul>
					<li class="flex-center-cross">
						<span>生产进度(%)：</span>
						<c-progress classs="flex-grow" :rate="[detailData.fine_count, detailData.plan_count]"></c-progress>
						<span>({{detailData.fine_count}}/{{detailData.plan_count}})</span>
					</li>
					<li class="flex-center-cross">
						<span>工序计划数：</span>
						<b>{{detailData.plan_count}}</b>
					</li>
					<li class="flex-center-cross">
						<span>加工类型：</span>
						<c-state dict="processTypeDic" :value="detailData.process_type"></c-state>
					</li>
					<li class="flex-center-cross" v-if="detailData.process_type == 2">
						<span>已委外数：</span>
						<b>{{detailData.out_sourcing_plan_count}}</b>
					</li>
					<li class="flex-center-cross">
						<span>检验方式：</span>
						<c-state dict="testModeDic" :value="detailData.test_mode"></c-state>
					</li>
					<li class="flex-center-cross" v-if="detailData.test_mode == 2">
						<span>首检状态：</span>
						<c-state dict="firestTestState" :value="detailData.firest_test_state"></c-state>
					</li>
					<li class="flex-center-cross">
						<span>良品数/不良品数：</span>
						<b style="color: var(--color-green)">{{detailData.fine_count}}</b>
						<span style="padding:0px 5px"> / </span>
						<b style="color: var(--color-red);">{{detailData.defects_count}}</b>
					</li>
					<li class="flex-center-cross">
						<span>良品数已审核/待审核：</span>
						<b>{{detailData.fine_count_2}}</b>
						<span style="padding:0px 5px"> / </span>
						<b>{{detailData.fine_count_1}}</b>
					</li>
					<li class="flex-center-cross" v-if="detailData.test_mode == 3">
						<span>已质检合格数：</span>
						<b>{{detailData.test_fine_count}}</b>
					</li>
					<li class="flex-center-cross">
						<span>计划开始时间：</span>
						<b>{{detailData.plan_start_date}}</b>
					</li>
					<li class="flex-center-cross">
						<span>计划结束时间：</span>
						<b>{{detailData.plan_end_date}}</b>
					</li>
					<li class="flex-center-cross">
						<span>最后报工时间：</span>
						<b>{{detailData.last_output_date || '-'}}</b>
					</li>
				</ul>
			</div>
		</c-dialog>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {debounce, createStore, mapStore} from '@deanwu/vue-component-library-mobile'

	const STORE = createStore(Vue.extend({
		data() {
			return {
				queue: [],
				data: {}
			}
		},

		watch: {
			queue(val) {
				if (val.length) {
					this.getData();
				}
			}
		},

		methods: {
			get(id) {
				if (!this.queue.includes(id)) {
					this.queue.push(id);
				}
			},

			getData: debounce(function() {
				let id = this.queue.map(id => {
					return {id};
				});
				this.request({
					url: '/work/statisticList',
					data: {
						work_list: id
					},
					success: data => {
						id.forEach(({id}) => {
							this.$set(this.data, id, data[id] || []);
						});
						this.$nextTick(() => {
							this.data = {};
						});
					}
				});
				this.queue = [];
			}, 500, false)
		}
	}));

	export default {
		name: 'processRate',
		
		props: {
			id: [Number, String]
		},

		data() {
			return {
				store: STORE,
				list: null,
				detailData: null
			}
		},

		computed: {
			...mapStore(['data'])
		},

		watch: {
			data(val) {
				if (val[this.id]) {
					this.list = val[this.id];
				}
			}
		},

		mounted() {
			this.store.get(this.id);
			document.body.appendChild(this.$refs.detail.$el);
		},

		beforeDestroy() {
			document.body.removeChild(this.$refs.detail.$el);
		},

		methods: {
			detailHandle(item) {
				this.request({
					url: '/task/detail',
					data: {
						id: item.id
					},
					loading: true,
					success: data => {
						this.detailData = data;
						this.$refs.detail.open();
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.process-rate {
		float: left;
		box-sizing: border-box;
		min-width: 100%;
		height: 1.56rem;
		padding: .15rem .2rem .05rem;

		.line {
			min-width: .4rem;
			height: 1px;
			margin: .44rem .12rem;
			background: #bbb;
		}

		.item {
			position: relative;
			margin-top: .02rem;

			.circle {
				border-radius: 50%;
			}
			
			p {
				width: .88rem;
				margin-top: .04rem;
				font-size: .24rem;

				span {
					min-width: 5em;
					text-align: center;
				}
			}

			.tag {
				position: absolute;
				left: 50%;
				top: 0;
				height: .3rem;
				border: 1px solid #fff;
				border-radius: .16rem
				padding: 0 .12rem;
				line-height: .32rem;
				font-size: .2rem;
				white-space: nowrap;
				color: #fff;
				transform: translate(-50%,-.1rem);
			}

			.state {
				position: absolute;
				left: .02rem;
				top: .6rem;
				width: .24rem;
				height: .24rem;
				border-radius: 50%
				font-size: .2rem;
				color: #fff;
			}
		}

		.empty {
			box-sizing: border-box;
			height: 100%;
			padding-bottom: .1rem;
		}

		&-detail {
			padding: 0 .4rem .3rem;

			.head {
				height: 1.1rem;

				p {
					font-size: .36rem;
					font-weight: bold;
				}
			}

			ul {
				li {
					height: .6rem;
					font-size: .26rem;
					white-space: nowrap;
					color: #666;

					b {
						color: #000;
					}
				}
			}
		}
	}
</style>
